/* Cart drawer add-on rail */
(function () {
  'use strict';

  try {
    if (new URLSearchParams(window.location.search).get('sales_channel') === 'venn_apps') return;
  } catch (e) {}

  var open = null;

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var row = event.target.closest('[data-crtz-open]');
    if (row) {
      stop(event);
      openPicker(row.getAttribute('data-crtz-open'));
      return;
    }

    if (!open) return;

    var swatch = event.target.closest('[data-crtz-swatch]');
    if (swatch) {
      stop(event);
      selectColour(swatch.getAttribute('data-crtz-swatch'));
      return;
    }

    var size = event.target.closest('[data-crtz-size]');
    if (size && !size.disabled) {
      stop(event);
      selectSize(size);
      return;
    }

    var add = event.target.closest('[data-crtz-add]');
    if (add && !add.disabled) {
      stop(event);
      addToCart(add.getAttribute('data-crtz-add'), add);
      return;
    }

    if (event.target.closest('[data-crtz-close]') || event.target === open) {
      stop(event);
      closePicker();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (open && event.key === 'Escape') {
      event.stopPropagation();
      closePicker();
    }
  }, true);

  function stop(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function openPicker(id) {
    closePicker();
    open = document.querySelector('[data-crtz-picker="' + id + '"]');
    if (!open) return;

    open.hidden = false;
    /* One frame so the transition runs from the start state. */
    requestAnimationFrame(function () {
      if (open) open.classList.add('is-open');
    });
  }

  function closePicker() {
    if (!open) return;
    var closing = open;
    open = null;
    closing.classList.remove('is-open');
    setTimeout(function () { closing.hidden = true; }, 200);
  }

  function selectColour(id) {
    each(open, '[data-crtz-colour]', function (panel) {
      panel.hidden = panel.getAttribute('data-crtz-colour') !== id;
    });
    status('');
  }

  function selectSize(button) {
    var panel = button.closest('[data-crtz-colour]');

    each(panel, '[data-crtz-size]', function (other) {
      other.classList.toggle('is-selected', other === button);
    });

    var add = panel.querySelector('[data-crtz-add]');
    add.setAttribute('data-crtz-add', button.getAttribute('data-crtz-size'));
    add.disabled = false;
    add.textContent = 'ADD TO CART';
  }

  function each(root, selector, fn) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  function status(text) {
    if (!open) return;
    var el = open.querySelector('.crtz-pick__status');
    if (el) el.textContent = text;
  }

  function addToCart(variantId, button) {
    button.classList.add('is-busy');
    status('Adding...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          return body;
        });
      })
      .then(function (body) {
        track((body.items && body.items[0]) || body);
        closePicker();
        refreshDrawer();
      })
      .catch(function (err) {
        button.classList.remove('is-busy');
        /* 422 means it sold out between render and tap. */
        status(err && err.status === 422 ? 'That just sold out.' : 'Could not add. Try again.');
      });
  }

  /* Re-render through the theme's own routine so the item count and the
     free-shipping bar move together. */
  function refreshDrawer() {
    if (typeof window.updateCartDrawer === 'function') return window.updateCartDrawer();
    if (typeof window.updateMainCart === 'function') return window.updateMainCart();
    window.location.reload();
  }

  /* Mirrors the event scripts.js fires on a product-form add. */
  function track(line) {
    if (!line || !window.ShopifyAnalytics || !window.ShopifyAnalytics.lib) return;
    try {
      window.ShopifyAnalytics.lib.track('product_added_to_cart', {
        variant_id: line.variant_id,
        name: line.product_title,
        price: line.price / 100,
        quantity: line.quantity,
        sku: line.sku,
        brand: line.vendor
      });
    } catch (e) {}
  }
})();
